import axios from 'axios'

const client = axios.create({
  json: true
})

export default {
  async execute(method, resource, data) {
    let accessToken = localStorage.getItem('user') || null
    try {
      const response = await client({
        method,
        data,
        url: resource,
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      return response.data
    } catch (error){
      return Promise.reject(error.response)
    }
  },

  async login(logindata) {
    return this.execute('post', '/api/login', logindata)
  },

  async register(registerdata) {
    return this.execute('post', '/api/users', registerdata)
  },
  
  async netsdetail() {
    return this.execute('get', '/api/netsdetail')
  },
  
  async sensorsMinMaxData(sensorsQuery) {
    let sensorsIds = []
    if (sensorsQuery.measurement == 'temperature'){
      sensorsIds = sensorsQuery.nets.map(({temperature})=> temperature)
    } else if (sensorsQuery.measurement == 'precipitation') {
      sensorsIds = sensorsQuery.nets.map(({precipitation})=> precipitation)
    }
    return this.execute('get', '/api/sensorsMinMaxData'
      + "?sensors=" + sensorsIds.join(',')
      + "&measurement=" + sensorsQuery.measurement
      + "&yearsViz=" + sensorsQuery.yearsViz
      + "&resolution=" + sensorsQuery.dataResolution.value
      + "&fromDate=" + sensorsQuery.dateRange.fromDate
      + "&toDate=" + sensorsQuery.dateRange.toDate)
  },

  async sensorsData(sensorsQuery) {
    let sensorsIds = []
    if (sensorsQuery.measurement == 'temperature'){
      sensorsIds = sensorsQuery.nets.map(({temperature})=> temperature)
    } else if (sensorsQuery.measurement == 'precipitation') {
      sensorsIds = sensorsQuery.nets.map(({precipitation})=> precipitation)
    }
    return this.execute('get', '/api/sensorsData'
      + "?sensors=" + sensorsIds.join(',')
      + "&measurement=" + sensorsQuery.measurement
      + "&yearsViz=" + sensorsQuery.yearsViz
      + "&resolution=" + sensorsQuery.dataResolution.value
      + "&fromDate=" + sensorsQuery.dateRange.fromDate
      + "&toDate=" + sensorsQuery.dateRange.toDate)
  },

  async getLastNetReadings(netId){
    try {
      return this.execute('get', '/api/netData/'+netId)
    } catch(err){
      console.log('getLastNetReadings', err)
    }


  }
}
